export enum PermissionHistoricalOption {
  DASHBOARD_HISTORICAL_COMMON_LOGIN = 'historico',
  DASHBOARD_HISTORICAL_LIST = '/historico/',
}
